module.exports = __webpack_public_path__ + "media/images/form-c58e9d84.png";